var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedRoundCross({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FF5F5F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9161 12.0001L16.8099 8.10608C17.0634 7.85279 17.0634 7.44325 16.8099 7.18997C16.5567 6.93668 16.1471 6.93668 15.8939 7.18997L11.9999 11.084L8.10614 7.18997C7.85274 6.93668 7.44333 6.93668 7.19005 7.18997C6.93665 7.44325 6.93665 7.85279 7.19005 8.10608L11.0839 12.0001L7.19005 15.8941C6.93665 16.1474 6.93665 16.5569 7.19005 16.8102C7.31628 16.9365 7.48225 17 7.6481 17C7.81395 17 7.9798 16.9365 8.10614 16.8102L11.9999 12.9162L15.8939 16.8102C16.0202 16.9365 16.1861 17 16.3519 17C16.5178 17 16.6836 16.9365 16.8099 16.8102C17.0634 16.5569 17.0634 16.1474 16.8099 15.8941L12.9161 12.0001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedRoundCross);
export default __webpack_public_path__ + "static/media/red-round-cross.0ab698800e0daf08b2a3691c53c22166.svg";
export { ForwardRef as ReactComponent };